import AppBar from '@mui/material/AppBar';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import { styled } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import AfficiencyLogo from '../images/afficiencylogo.png';
import { AuthContext } from '../libs/contexts/authContext';
import { ResponsiveContext } from '../libs/contexts/responsiveContext';
import NotificationWithAlerts from '../theme/NotificationWithAlerts';
import SBLILogo from '../images/sbli-logo.png';
import { concatFullName } from '../libs/utils'
import MenuIcon from '@mui/icons-material/Menu'
import ForestersLogo from '../images/ForestersLogo.png'
import AvantLogo from '../images/avantLogo.svg'

const ContactSupportButton = ({ disabled }) => {
  const { productId } = useContext(AuthContext)
  console.log(productId)
  console.log({ disabled })
  if (disabled) {
    return (
      <Button
        variant="outlined"
        sx={{
          textTransform: 'none',
          borderRadius: '2rem',
          color: '#3C4FB9',
          backgroundColor: '#C4CAF1',
          borderColor: 'transparent',
          marginX: '8px',
          height: '42px',
        }}
        disabled
      >
        Contact Support
      </Button>
    )
  }
  return (
    <a
      href= {getCustomerSupportURLs(productId)}
      target="_blank"
      rel="noreferrer"
      style={{ all: 'unset' }}
    >
      <Button
        variant="outlined"
        sx={{
          textTransform: 'none',
          borderRadius: '2rem',
          color: '#3C4FB9',
          backgroundColor: '#C4CAF1',
          borderColor: 'transparent',
          marginX: '8px',
          height: '42px',
        }}
      >
        Contact Support
      </Button>
    </a>
  )
}

const FAQButton = () => {
  const { productId, company } = useContext(AuthContext)

  return (
    <>
      {company === 'avant' ? (
        <Button
          // disabled={}
          disabled
          variant="outlined"
          sx={{
            textTransform: 'none',
            borderRadius: '2rem',
            color: '#3C4FB9',
            backgroundColor: '#C4CAF1',
            borderColor: 'transparent',
            height: '42px',
          }}
        >
          Frequently Asked Questions
        </Button>
      ) : (
        <a
          href={
            productId === '4127' || company === 'foresters'
              ? 'https://www.afficiency.com/lwp-application-management-portal-faqs-0-0'
              : productId === '81403'
              ? 'https://www.afficiency.com/sbli-application-management-portal-faqs-0?hs_preview=IAtWATWl-183193799269'
              : 'https://www.afficiency.com/sbli-application-management-portal-faqs'
          }
          target="_blank"
          rel="noreferrer"
          style={{ all: 'unset' }}
        >
          <Button
            // disabled={}
            variant="outlined"
            sx={{
              textTransform: 'none',
              borderRadius: '2rem',
              color: '#3C4FB9',
              backgroundColor: '#C4CAF1',
              borderColor: 'transparent',
              height: '42px',
            }}
          >
            Frequently Asked Questions
          </Button>
        </a>
      )}
    </>
  )
}

const ProfileBox = ({ fullName, isMobile }) => {
  if (isMobile) {
    return (
      <Avatar sx={{ bgcolor: '#673ab7', width: 32, height: 32, marginRight: '10px', fontSize: '16px' }}>
        {fullName
          ?.split(' ')
          .map((word) => word.charAt(0).toUpperCase())
          .join('')}
      </Avatar>
    )
  }
  return (
    <Box
      sx={{
        display: 'flex',
        backgroundColor: '#C4CAF1',
        alignItems: 'center',
        borderRadius: '100px',
        padding: '2px 5px',
        height: '40px',
      }}
    >
      <Avatar sx={{ bgcolor: '#673ab7', width: 32, height: 32, marginRight: '10px', fontSize: '16px' }}>
        {fullName
          ?.split(' ')
          .map((word) => word.charAt(0).toUpperCase())
          .join('')}
      </Avatar>
      <span
        style={{
          fontFamily: 'Roboto',
          fontWeight: 500,
          fontSize: '14px',
          lineHeight: '20px',
          color: '#3C4FB9',
          marginRight: '10px',
        }}
      >
        {fullName}
      </span>
    </Box>
  )
}

export const getCustomerSupportURLs = (productId) => {
  const customerSupportUrlsMap = {
    4127: 'https://support.afficiency.com/lwp/i-need-help-from-customer-support-on-foresters-live-well-plus',
    81401: 'https://support.afficiency.com/qlt/i-need-help-from-customer-support-on-quility-level-term',
    81403: 'https://support.afficiency.com/alt/i-need-help-from-customer-support-on-assure-level-term',
    511801: 'https://support.afficiency.com/newbridgefx/i-need-help-on-newbridge-final-expense',
    default:
      'https://support.afficiency.com/knowledge/how-do-i-get-help-about-an-application-agent-set-up-or-platform-issues',
  }
  return productId && productId in customerSupportUrlsMap ? customerSupportUrlsMap[productId]: customerSupportUrlsMap['default']
}

export const Logo = styled('div')({
  flexGrow: 1,
  display: 'flex',
  alignItems: 'center',
  '& img': {
    maxWidth: { lg: '180px', md: '150px', xs: '100px' },
    height: 'auto',
  },
  marginLeft: '30px',
})

const AuthenticatedNavbar = ({
  companyLogo,
  drawerOpen,
  alerts,
  setAlerts,
  firstName,
  lastName,
  toggleDrawer,
  disableContactSupport,
}) => {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'))

  return (
    <Toolbar sx={{ display: 'flex', justifyContent: 'space-between', padding: '5px 0' }}>
      {isSmallScreen && !drawerOpen && (
        <IconButton sx={{ ml: 1 }}>
          <MenuIcon onClick={() => toggleDrawer(!drawerOpen)} />
        </IconButton>
      )}
      {!isSmallScreen && companyLogo ? (
        <Logo>
          <img src={companyLogo ? companyLogo : SBLILogo} alt="Logo" width="150px" />
        </Logo>
      ) : (
        <div></div>
      )}
      <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end', alignItems: 'center', pr: 2 }}>
        <NotificationWithAlerts alerts={alerts} setAlerts={setAlerts} />
        <FAQButton />
        {!isSmallScreen && <ContactSupportButton disabled={disableContactSupport} />}
        {firstName && <ProfileBox fullName={concatFullName(firstName, lastName)} isMobile={isSmallScreen} />}
      </Box>
    </Toolbar>
  )
}

const Navbar = ({ drawerOpen, toggleDrawer }) => {
  const [logo, setLogo] = useState('')

  const { isMobile, isTablet } = useContext(ResponsiveContext)
  const {
    orgObject: { companyLogo },
    agentObject: { firstName, lastName },
    alerts,
    setAlerts,
    authObj,
    company,
  } = useContext(AuthContext)

  useEffect(() => {
    const LOGO =
      RELATIONAL_TYPE === 117
        ? AfficiencyLogo
        : company === 'foresters'
        ? ForestersLogo
        : company === 'avant'
        ? AvantLogo
        : company === 'sbli' || company === 'assure'
        ? SBLILogo
        : null
    setLogo(LOGO)
  }, [company])

  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'))

  const loggedIn = useSelector((state) => state.auth.isAuthenticated)
  const relationalType = useSelector((state) => state.auth.relationalType)

  const affFirstName = useSelector((state) => state.auth.firstName)
  const affLastName = useSelector((state) => state.auth.lastName)

  const RELATIONAL_TYPE = company === 'foresters' ? authObj.relationalType : relationalType
  const FIRST_NAME =
    company === 'foresters' ? authObj.user?.firstName : relationalType === 117 ? affFirstName : firstName
  const LAST_NAME = company === 'foresters' ? authObj.user?.lastName : relationalType === 117 ? affLastName : lastName

  const isDemo = window.location.href.includes('demo')
  return (
    <AppBar
      position="fixed"
      sx={{
        bgcolor: logo ? 'rgb(241, 243, 246)' : '#fff',
        boxShadow: 'none',
        flexGrow: 0,
        transition: (theme) =>
          theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
        width: isSmallScreen ? '100%' : `calc(100% - ${drawerOpen ? 270 : 0}px)`,
        zIndex: (theme) => theme.zIndex.drawer - 2,
      }}
    >
      {loggedIn || authObj.isAuthenticated ? (
        <AuthenticatedNavbar
          companyLogo={logo}
          drawerOpen={drawerOpen}
          alerts={alerts}
          setAlerts={setAlerts}
          firstName={FIRST_NAME}
          lastName={LAST_NAME}
          toggleDrawer={toggleDrawer}
          disableContactSupport={false}
        />
      ) : (
        <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
          {logo ? (
            <Logo>
              <img src={logo} alt="Logo" width="150px" />
            </Logo>
          ) : (
            <div></div>
          )}
          {!isSmallScreen && <ContactSupportButton disabled={false} />}

          {firstName && loggedIn && (
            <ProfileBox fullName={concatFullName(firstName, lastName)} isMobile={isSmallScreen} />
          )}
        </Toolbar>
      )}
    </AppBar>
  )
}

export default Navbar;
